<template>
  <div id="item-storage-select">
    <!-- NO ASSET: PROVIDE SELECTION & UPLOAD CONTROLS (broadcaster view)-->
    <template v-if="!storage_asset && !isPodcaster">
      <div class="row storage-selection">
        <div class="col-6">
          <label class="font-weight-bold">Choose or add a Storage Asset: <em class="font-bold text-danger cursor-help" title="Required">*</em></label>
        </div>
        <div class="col-6 col-md-10">
          <storage-selector />
        </div>
      </div>

      <div class="row my-2">
        <div class="col-12">
          <uploader-dropzone post-url="/api/v1/storage" :single-upload="true" />
        </div>
      </div>
    </template>

    <!-- Podcaster View -->
    <template v-else-if="!storage_asset && isPodcaster">
      <div class="row">
        <div class="col-12 mb-4">
          <uploader-dropzone post-url="/api/v1/storage"
                             :single-upload="true"
                             :center="true"
                             upload-button-text="Upload Media" />
        </div>
        <div class="text-center w-100">
          <p>- or -</p>
          <a v-if="!storage_selection_visible"
             href="javascript:;"
             @click="setStorageSelectionVisibility">
            Select Existing Media
          </a>
        </div>

        <div v-if="storage_selection_visible" class="col-12">
          <storage-selector />
        </div>
      </div>
    </template>

    <!-- ASSET GIVEN: HIDE SELECT & UPLOAD CONTROLS, DISPLAY SUMMARY & CLEAR BUTTON -->
    <div v-else class="row">
      <div class="col-12 d-flex flex-row align-items-center">
        <strong class="mr-2">Selected Storage Asset: </strong>
        <a :href="`/storage/${storage_asset.uuid}/edit`">{{ storage_asset.name }}</a>
        <button type="button"
                title="Clear"
                class="btn link-like d-inline-block pl-2"
                @click="removeStorageAsset">
          <i class="la la-close p-0" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import StorageSelector from "VuePartials/Storage/StorageSelector";
import UploaderDropzone from "VuePartials/UploaderDropzone";

export default {
  components: {
    UploaderDropzone,
    StorageSelector,
  },
  props: {
    value: {
      type: Object,
      required: false,
      default: null,
    },
  },
  data: function () {
    return {
      storage_asset: this.value,
      storage_selection_visible: false,
    };
  },
  watch: {
    storage_asset: function (new_value) {
      this.$emit("input", new_value);
    },
  },
  mounted() {
    // Storage Asset chosen from <storage-selector>
    EventBus.$on("storage_asset_selected", (payload) => {
      this.storage_asset = payload;
    });

    // Storage Asset Uploaded from <uploader-dropzone>
    EventBus.$on("storage_asset_uploaded", (payload) => {
      this.storage_asset = payload;
    });
  },
  methods: {
    setStorageSelectionVisibility(visible = true) {
      this.storage_selection_visible = visible;
    },
    removeStorageAsset() {
      this.setStorageSelectionVisibility(false);
      this.storage_asset = null;
    },
  },
};
</script>
